import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // Hard 20s ceiling on any single request — prevents the UI from hanging
  // indefinitely if the backend or network stalls.
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** Extract a human-readable Arabic-safe error message from an axios error.
 *  FastAPI returns 422 errors as `detail: [{type, loc, msg, ...}, ...]` which
 *  cannot be rendered directly in a React toast. */
export const extractApiErrorMessage = (err, fallback = "حدث خطأ غير متوقع") => {
  // Axios timeout / network failures
  if (err?.code === "ECONNABORTED") {
    return "تأخّر الاتصال بالخادم، تحقّق من الإنترنت ثم حدّث الصفحة";
  }
  if (err?.message === "Network Error") {
    return "تعذّر الاتصال بالخادم، يرجى تحديث الصفحة";
  }
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d === "object" ? d.msg || d.type || JSON.stringify(d) : String(d)))
      .join(" • ");
  }
  if (typeof detail === "object") return detail.msg || JSON.stringify(detail);
  return String(detail);
};

export default api;
